import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Typography, TextField, Button, Paper, Alert } from '@mui/material'
import { Send as SendIcon } from '@mui/icons-material'
import { supabase } from '../../supabaseClient'
import { useAuth } from '../../contexts/AuthContext'
import CommunityLayout from '../../components/community/CommunityLayout'

function NewPost() {
  const navigate = useNavigate()
  const { user } = useAuth()
  const [title, setTitle] = useState('')
  const [body, setBody] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async e => {
    e.preventDefault()
    setLoading(true)
    setError('')

    if (!title.trim() || !body.trim()) {
      setError('Title and body are required')
      setLoading(false)
      return
    }

    try {
      const { data, error: postError } = await supabase
        .from('posts')
        .insert([
          {
            title: title.trim(),
            body: body.trim(),
            author_id: user.id,
          },
        ])
        .select()
        .single()

      if (postError) throw postError

      navigate(`/community/post/${data.id}`)
    } catch (err) {
      console.error('Error creating post:', err)
      setError(err.message || 'Failed to create post')
    } finally {
      setLoading(false)
    }
  }

  if (!user) {
    return (
      <CommunityLayout>
        <Alert severity="warning">Please sign in to create a post.</Alert>
      </CommunityLayout>
    )
  }

  return (
    <CommunityLayout>
      <Paper elevation={0} sx={{ p: 4, border: 1, borderColor: 'divider' }}>
        <Typography variant="h5" fontWeight={700} sx={{ mb: 3, color: 'text.primary' }}>
          Create New Post
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Title"
            value={title}
            onChange={e => setTitle(e.target.value)}
            required
            disabled={loading}
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            label="Body"
            value={body}
            onChange={e => setBody(e.target.value)}
            required
            multiline
            rows={8}
            disabled={loading}
            sx={{ mb: 3 }}
          />

          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              type="submit"
              variant="contained"
              startIcon={<SendIcon />}
              disabled={loading}
              sx={{
                background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                textTransform: 'none',
                fontWeight: 600,
              }}
            >
              {loading ? 'Creating...' : 'Create Post'}
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate('/community')}
              disabled={loading}
              sx={{ textTransform: 'none' }}
            >
              Cancel
            </Button>
          </Box>
        </form>
      </Paper>
    </CommunityLayout>
  )
}

export default NewPost
